import type { AppDef } from "../../shell/nav";
import { ApiClientsPage } from "./ApiClientsPage";
import { BulkJobsPage } from "./BulkJobsPage";
import { ConnectorsPage } from "./ConnectorsPage";
import { ContactsPage } from "./ContactsPage";
import { CustomAttributesPage } from "./CustomAttributesPage";
import { DeviceCertsPage } from "./DeviceCertsPage";
import { DomainPage } from "./DomainPage";
import { IpGroupsPage } from "./IpGroupsPage";
import { LogsPage } from "./LogsPage";
import { PolicyGroupsPage } from "./PolicyGroupsPage";
import { PolicySettingsPage } from "./PolicySettingsPage";
import { PolicyTemplatesPage } from "./PolicyTemplatesPage";
import { ProvidersPage } from "./ProvidersPage";
import { ReconciliationPage } from "./ReconciliationPage";
import { RunsPage } from "./RunsPage";
import { UserDetailPage } from "./UserDetailPage";
import { UsersPage } from "./UsersPage";

export const IDP: AppDef = {
  key: "idp",
  name: "ID管理",
  // `/idp` に来たときは今までどおり突合(R5 からの動きを変えない)
  defaultPath: "reconciliation",
  // 一覧(`users`)の右パネル → 「全画面で開く」で来る固有 URL
  extraRoutes: [{ path: "users/:userId", component: UserDetailPage }],
  groups: [
    {
      label: "ユーザー",
      items: [
        { path: "users", label: "ユーザー一覧", phase: "R7b", component: UsersPage, feature: "idp.users" },
        {
          path: "custom-attributes",
          label: "カスタム属性",
          phase: "R7b",
          component: CustomAttributesPage,
          feature: "idp.users",
        },
        { path: "bulk-jobs", label: "一括登録の履歴", phase: "R7b", component: BulkJobsPage, feature: "idp.users" },
        {
          path: "device-certs",
          label: "端末証明書",
          phase: "R7e",
          component: DeviceCertsPage,
          // 一覧・発行・失効はすべて operator 以上。viewer には出さない(低 2)
          role: "idp:operator",
          feature: "idp.device-cert",
        },
      ],
    },
    {
      label: "アクセスポリシー",
      items: [
        { path: "policy", label: "アクセスポリシー", phase: "R7d", component: PolicyGroupsPage, feature: "idp.policy" },
        { path: "policy/ip-groups", label: "IP グループ", phase: "R7d", component: IpGroupsPage, feature: "idp.policy" },
        {
          path: "policy/templates",
          label: "ポリシーテンプレート",
          phase: "R7d",
          component: PolicyTemplatesPage,
          feature: "idp.policy",
        },
        {
          path: "policy/settings",
          label: "ポリシー設定",
          phase: "R7d",
          component: PolicySettingsPage,
          feature: "idp.policy",
        },
      ],
    },
    {
      label: "ログ",
      items: [{ path: "logs", label: "ログ", phase: "R7c", component: LogsPage, feature: "idp.logs" }],
    },
    {
      label: "突合",
      items: [
        {
          path: "reconciliation",
          label: "アカウント突合",
          phase: "R5",
          component: ReconciliationPage,
          feature: "idp.reconcile",
        },
        { path: "runs", label: "実行履歴", phase: "R5", component: RunsPage, feature: "idp.reconcile" },
      ],
    },
    {
      label: "サービスプロバイダー",
      items: [
        {
          path: "providers",
          label: "サービスプロバイダー",
          phase: "R7a",
          component: ProvidersPage,
          feature: "idp.sso",
        },
      ],
    },
    {
      label: "ドメイン設定",
      items: [
        { path: "domain", label: "ドメイン設定", phase: "R7b", component: DomainPage, feature: "idp.users" },
        {
          path: "api-clients",
          label: "API クライアント",
          phase: "R7b",
          component: ApiClientsPage,
          feature: "idp.users",
        },
      ],
    },
    {
      label: "設定",
      items: [
        // 接続先(Keycloak / GWS)は SSO 専用の設定ではない。ユーザー管理でも突合でも
        // 同じ接続を使うので、どれか 1 つでもあれば出す(API も同じ any の門)
        {
          path: "connectors",
          label: "SaaSコネクタ設定",
          phase: "R5",
          component: ConnectorsPage,
          feature: ["idp.sso", "idp.users", "idp.reconcile"],
        },
        // 電話帳同期(CS1)。GWS 連携のオプション
        {
          path: "contacts",
          label: "電話帳",
          phase: "CS1",
          component: ContactsPage,
          feature: "idp.contacts-sync",
        },
      ],
    },
  ],
};
